function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Button from "../../../../components/mui/material/Button";
import Dialog from "../../../../components/mui/material/Dialog";
import { useThemeContext } from "../../../../contexts/ThemeContext";
var tKey = "features.Chat.Groups.ApplicationUnavailableListItem";
function ApplicationUnavailableListItem(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    theme = _useThemeContext.theme;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, {
    disablePadding: true,
    sx: {
      bgcolor: theme === "dark" ? "rgb(22, 11, 11)" : "rgb(253, 237, 237)",
      color: theme === "dark" ? "rgb(244, 199, 199)" : "rgb(95, 33, 32)"
    }
  }, /*#__PURE__*/React.createElement(ListItemButton, null, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
    sx: {
      bgcolor: theme === "dark" ? "rgb(244, 199, 199)" : "rgb(95, 33, 32)"
    }
  }, /*#__PURE__*/React.createElement(ErrorOutlineIcon, null))), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "Application is currently unavailable"
  }))), /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    PaperProps: {
      elevation: 0,
      sx: {
        boxShadow: "none",
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))"
      }
    },
    sx: {
      backdropFilter: "blur(5px) sepia(5%)"
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, t("".concat(tKey, ".applicationUnavailable"))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, t("".concat(tKey, ".problemPersists")))), /*#__PURE__*/React.createElement(DialogActions, {
    sx: {
      justifyContent: "start",
      pl: 3
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: function onClick() {
      return setOpen(false);
    }
  }, t("".concat(tKey, ".ok"))))), /*#__PURE__*/React.createElement(Divider, {
    component: "li"
  }));
}
export default ApplicationUnavailableListItem;